import moment from 'moment';

export const timeZoneDate = (key: any) => moment.utc(key);